export const TEXT={
    Login:{
        en:"Login",
        ar:"تسجيل الدخول"
    },
    Register:{
        en:"Register",
        ar:"تسجيل"
    },
    EmailAddress:{
        en:"Email Address",
        ar:"البريد الالكتروني"
    },
    Password:{
        en:"Password",
        ar:"كلمة المرور"
    },
    ConfirmPassword:{
        en:"Confirm Password",
        ar:"تأكيد كلمة المرور"
    },
    FirstName:{
        en:"First Name",
        ar:"الاسم الاول"
    },
    LastName:{
        en:"Last Name",
        ar:"الاسم الاخير"
    },
    DontHaveAccount:{
        en:"Don't have an account?",
        ar:"ليس لديك حساب؟"
    },
    RememberMe:{
        en:"Remember me",
        ar:"تذكر بياناتي"
    },
    ForgetPassword:{
        en:"Forget Password",
        ar:"نسيت كلمة المرور"
    }
}
export default TEXT;  